/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Drop_HereInputs */

const vi_media_drop_here = /** @type {(inputs: Media_Drop_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thả file vào đây để tải lên`)
};

/**

* @param {Media_Drop_HereInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_drop_here = /** @type {((inputs?: Media_Drop_HereInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Drop_HereInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_drop_here(inputs)
});